import clsx from 'clsx';

export const Plus = ({ isOpen }: { isOpen?: boolean }) => {
  return (
    <div
      className={clsx(
        'relative w-full h-full transform transition-all',
        {
          'rotate-45': isOpen,
        }
      )}
    >
      <div
        className="absolute w-full transform -translate-y-1/2 bg-black top-1/2"
        style={{
          height: 1,
        }}
      />
      <div
        className="absolute h-full transform -translate-x-1/2 bg-black left-1/2"
        style={{
          width: 1,
        }}
      />
    </div>
  );
};
